import { render, staticRenderFns } from "./AknowledgeNoItemsMatch.vue?vue&type=template&id=3bd7c8b6&"
import script from "./AknowledgeNoItemsMatch.vue?vue&type=script&lang=js&"
export * from "./AknowledgeNoItemsMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports